import { BaseModel } from '@shared/models/base.model'

import { Role } from './role.model'
import { User } from './user.model'
import { Team } from './team.model'

export class Setting extends BaseModel {
  role: Role
  user?: User
  team?: Team
  name: SettingName
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any
  roleId?: string
  teamId?: number
  dateFormat?: string
}

export interface InputSetting {
  roleId: number
  teamId: number
  name: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any
}

export enum SettingName {
  OTP = 'otp',
  SMS = 'sms',
  Email = 'email',
  InApp = 'inApp',
  Theme = 'theme',
  Provider = 'provider',
  MapApiOptions = 'mapApiOptions',
  Timezone = 'timezone',
  LoginWithId = 'loginWithId',
  TrackingLink = 'trackingLink',
  Asset = 'asset',
  EnableSOSInApp = 'enableSOSInApp',
  HideMapInApp = 'hideMapInApp',
  HideDrivingBehaviorInApp = 'hideDrivingBehaviorInApp',
  HideFormsOnTheDashboardsInMobileApp = 'hideFormsOnTheDashboardsInMobileApp',
  DriverAutologout = 'driverAutoLogoutOption',
  DigitalForm = 'digitalForm',
  Integrations = 'integrations',
  DisallowDriverLoginWebapp = 'disallowDriverLoginWebapp',
  NotificationPopup = 'notificationPopup',
  NotificationSound = 'notificationSound',
  SoundVolume = 'soundVolume',
  NotificationTemplate = 'notificationTemplate',
  IntercomFrame = 'intercomFrame',
  VehicleMapTitleInsteadOfRegno = 'vehicleMapTitleInsteadOfRegno',
  VehicleMapFieldWithIcon = 'vehicleMapFieldWithIcon',
  Messenger = 'messenger',
  Billing = 'billing',
  ReportRoutesCorrectedOnly = 'reportRoutesCorrectedOnly',
  XeroEnabled = 'xeroEnabled',
  Stripe = 'stripe',
  ReportsOptions = 'reports',
  RoyHillMaps = 'royHillMaps',
  DateFormat = 'dateFormat',
  UserTermsAcceptance = 'userTermsAcceptance',
  TripCode = 'tripCode',
  BillableAddons = 'billableAddons',
  Cameras = 'cameras',
  BMA = 'bma',
  Blockout = 'blockout',
}

export enum TooltipDisplaySetting {
  Title = 'title',
  Regno = 'regno',
  TitleRegno = 'titleAndRegno',
  Drivers = 'drivers',
  RegnoDriver = 'regnoAndDriver',
  TitleDriver = 'titleAndDriver',
}

export interface VehicleDisplaySettings {
  vehicleMapTitleInsteadOfRegno: boolean
  vehicleMapFieldWithIcon: TooltipDisplaySetting
}
